import { LiquidityIntentReview } from "@/features/treasury/liquidity";

export default function TreasuryLiquidityIntentPage() {
  return <LiquidityIntentReview />;
}